import cx from 'classnames';
import { type ReactNode } from 'react';
import { Button, ButtonVariants } from '@components/button/Button';
import typography from '~styles/typography.scss';
import {
  AuthModalTypes,
  useAuthModalContext,
} from '../context/AuthModalContext';
import styles from './Unauthenticated.scss';

export interface UnauthenticatedProps {
  className?: string;
  subtitle: ReactNode;
  title: string;
}

export const Unauthenticated = ({
  className,
  subtitle,
  title,
}: UnauthenticatedProps) => {
  const { openModal } = useAuthModalContext();

  return (
    <main className={cx(styles.container, className)}>
      <h1 className={cx(typography.d3, styles.title)}>{title}</h1>
      {subtitle && (
        <p className={cx(typography.c2, styles.subtitle)}>{subtitle}</p>
      )}
      <Button
        className={styles.loginButton}
        label="Login"
        onClick={() =>
          openModal(AuthModalTypes.SIGN_IN, { hideCreateAccount: true })
        }
        variant={ButtonVariants.Primary}
      />
      <p className={cx(typography.c2, styles.signUpText)}>
        Book a reservation with one of our partner restaurants to get started.
      </p>
    </main>
  );
};
